export default __webpack_public_path__ + "static/media/home-startup-text-bg.7412becd.jpg";